import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import store from "store";
import { commonActions } from "store/common";
import { IShippingDest, IShippingAddressCreate, IShippingAddressUpdate } from "../types/client_detail";
import { createShippingDestApi, fetchShippingDestApi, updateShippingDestApi } from "../api/shippingDestApi";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
/**
  * the hook for shipping address list
 */
const useShippingAddressList = () => {
  const { id } = useParams();
  const clientCode = useQuery().get("client_cd");
  const [addressList, setAddressList] = useState<IShippingDest[]>([]);
  const [hasMore, setHasMore] = useState(0);
  const [query, setQuery] = useState({
    limit: 50,
    offset: 1,
    client_cd: clientCode
  });
  const [isFetching, setIsFetching] = useState(false);

  const setPage = () => {
    setQuery((prevQuery) => ({ ...prevQuery, offset: prevQuery.offset + 1 }));
  }

  const fetchData = async () => {
    setIsFetching(true);
    const payload = {
      limit: query.limit,
      offset: query.offset,
      client_cd: query.client_cd,
    };
    try {
      const { list, total } = await fetchShippingDestApi(payload);
      if (query.offset > 1) {
        setAddressList((prev) => [...prev, ...list]);
      } else {
        setAddressList(list);
      }
      if (query.offset * query.limit >= total) {
        setHasMore(0);
      } else {
        setHasMore(hasMore + 1);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    } finally {
      setIsFetching(false);
    }
  };

  const createShippingDest = async (data: IShippingAddressCreate) => {
    setIsFetching(true);
    store.dispatch(commonActions.setLoading());
    try {
      await createShippingDestApi(data);
      await fetchData();
    } catch (error) {
      console.error("Error creating shipping dest:", error);
      throw error;
    } finally {
      setIsFetching(false);
      store.dispatch(commonActions.removeLoading());
    }
  }

  const updateShippingDest = async (data: IShippingAddressUpdate) => {
    setIsFetching(true);
    store.dispatch(commonActions.setLoading());
    try {
      await updateShippingDestApi(data);
      await fetchData();
    } catch (error) {
      console.error("Error updating shipping dest:", error)
      throw error;
    } finally {
      setIsFetching(false);
      store.dispatch(commonActions.removeLoading());
    }
  }

  useEffect(() => {
    fetchData();
  }, [query.offset]);

  return { addressList, hasMore, setPage, createShippingDest, isFetching, updateShippingDest };
};

export default useShippingAddressList;
